import { Injectable, NgZone, OnDestroy } from "@angular/core";
import { SwUpdate, VersionEvent } from "@angular/service-worker";
import { Subscription, interval } from "rxjs";

@Injectable({ providedIn: "root" })
export class NewVersionCheckerService implements OnDestroy {
	isNewVersionAvailable: boolean = false;
	version: any;
	buildDate: any;
	intervalSource = interval(16 * 60 * 1000); // every 15 mins
	intervalSubscription: Subscription;

	constructor(private swUpdate: SwUpdate, private zone: NgZone) {
		this.checkForUpdate();
	}

	checkForUpdate(): void {
		this.intervalSubscription?.unsubscribe();
		if (!this.swUpdate.isEnabled) {
			return;
		}

		this.zone.runOutsideAngular(() => {
			this.intervalSubscription = this.intervalSource.subscribe(() => {
				try {
					this.swUpdate.checkForUpdate();
				} catch (error) {
					console.error("Failed to check for updates:", error);
				}
			});
		});

		this.swUpdate.versionUpdates.subscribe((update: VersionEvent) => {
			if (update.type == "VERSION_DETECTED") {
				this.isNewVersionAvailable = true;
				this.version = (update.version?.appData as any).version;
				this.buildDate = (update.version?.appData as any).buildDate;
				console.log(`New  Version ${this.version} available (Build: ${this.buildDate})`);
			}
		});
	}

	applyUpdate(): void {
		// Reload the page to update to the latest version after the new version is activated
		this.swUpdate
			.activateUpdate()
			.then(() => document.location.reload())
			.catch((error) => console.error("Failed to apply updates:", error));
	}

	ngOnDestroy(): void {
		this.intervalSubscription?.unsubscribe();
	}
}
